import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import VendorPage from "@/pages/VendorPage";
import VendorsList from "@/pages/VendorsList";
import CartPage from "@/pages/CartPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Wishlist from "@/pages/Wishlist";
import VendorApply from "@/pages/VendorApply";
import VendorDashboard from "@/pages/VendorDashboard";
import Orders from "@/pages/Orders";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <WishlistProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:category" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/vendors" element={<VendorsList />} />
              <Route path="/vendor/apply" element={<VendorApply />} />
              <Route path="/vendor/dashboard" element={<VendorDashboard />} />
              <Route path="/vendor/:slug" element={<VendorPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
      </WishlistProvider>
    </AuthProvider>
  );
}
export default App;
